<template>
  <div class="container">
    <CollapsibleListItem icon="mdi-heart" :title="$t('SPECIAL_SPONSOR.HEADER')" :expanded="true">
      <m-row>
        <m-col lg="12">
          <m-row v-if="sponsors.length">
            <m-col
              v-for="sponsor in sponsors"
              :key="sponsor.id"
              lg="12"
              class="sponsor-col"
            >
              <memlist-card class="sponsor-card mx-auto">
                <div class="sponsor-content">
                  <a v-if="sponsor.main_href" :href="sponsor.main_href" target="_blank" rel="noopener">
                    <img
                      v-if="sponsor.logo_url"
                      :src="sponsor.logo_url"
                      alt="Logo"
                      class="sponsor-logo"
                    />
                  </a>
                  <img
                    v-else-if="sponsor.logo_url"
                    :src="sponsor.logo_url"
                    alt="Logo"
                    class="sponsor-logo"
                  />
                  <div class="sponsor-name">{{ sponsor.name }}</div>
                  <div class="sponsor-descr" v-html="sponsor.descr"></div>
                </div>
              </memlist-card>
            </m-col>
          </m-row>
          <div v-else class="text-center">{{ $t('COMMON.NO_DATA') }}</div>
        </m-col>
      </m-row>
    </CollapsibleListItem>
  </div>
</template>



<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { is_mobile } from '@/core/services/utils';
import CollapsibleListItem from './CollapsibleListItem.vue';

export default {

  name: 'MemberTableSponsors',

  props: [ 'member','expanded'],
  emits: ['save_data'],
  mixins: [ toasts ],

  components: {
    CollapsibleListItem
  },

  watch: {
    member: {
      deep: true,
      handler(val) {
        this.get_sponsors();
      },
      immediate: true
    },
  },

  computed: {
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {

    async get_sponsors() {
      try {
        const res = await axios.get(`/sponsor/published`);

        if (res.status === 200) {
          this.sponsors = res.data;
        }
      }
      catch (err) {
        console.error('get_sponsors error', err);
      }
    },

    async save_data() {

      this.$emit('save_data', this.member);

    }

  },

  async mounted() {
    this.show_form = this.expanded;

    await this.get_sponsors();
  },

  data() {
    return {

      sponsors: [],

      show_form: true,

    };
  }
};

</script>

<style lang="scss" scoped>
  
  @import "@/assets/sass/components/forms/_common_modals.scss";

.sponsor-col {
  margin-bottom: 20px;
}

.sponsor-card {
  max-width: 600px;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sponsor-logo {
  max-width: 120px;
  max-height: 120px;
  object-fit: contain;
  margin-bottom: 10px;
}

.sponsor-name {
  font-weight: bold;
  margin-bottom: 10px;
}

.sponsor-descr {
  text-align: left;
  font-size: 0.9rem;
}
</style>
